import React from "react";
import { motion } from "framer-motion";
import { ballMotion } from "../../../animations/framer";
import { booksFirst, booksSecond, booksThird } from "../../../data/books";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import { FormattedMessage } from "react-intl";

const style = {
	teamWrapper: `mb-12 lg:mb-0 py-4 overflow-hidden lg:basis-1/2`,
	titleWrapper: `mb-12`,
	title: `text-lg tracking-wide text-center text-lime lg:text-4xl uppercase aubrey-pro font-bold`,
	authors: `mb-10`,
	books: `mb-4`,
	postTitleWrapper: `mb-6`,
	members: `relative`,
	membs: `flex items-center justify-center gap-4 mb-4`,
	profile: `flex flex-col items-center text-xs whitespace-nowrap z-10`,
	imgBook: `mb-4 w-[100px] h-[150px] rounded-sm object-cover`,
	neonLime: `absolute top-[10%] left-[30%] shadow-[0px_0px_50px_30px_#DAF66A]`,
	neonLimeTwo: `absolute top-[50%] left-[60%] shadow-[0px_0px_50px_30px_#DAF66A]`,
	neonBlue: `absolute top-[60%] left-[40%] shadow-[0px_0px_50px_30px_#4430D0]`,
	neonBlueTwo: `absolute top-[10%] left-[20%] shadow-[0px_0px_50px_30px_#4430D0]`,
	neonRed: `absolute top-[40%] left-[20%] shadow-[0px_0px_50px_30px_#FB7151]`,
	neonRedTwo: `absolute top-[10%] left-[70%] shadow-[0px_0px_50px_30px_#FB7151]`,
};

const Team = () => {
	return (
		<div className={style.teamWrapper}>
			<div className={style.titleWrapper}>
				<h2 className={style.title}>
					<FormattedMessage id='courseBooks' />
				</h2>
			</div>
			<div className={style.members}>
				<motion.div
					variants={ballMotion}
					animate='startone'
					className={style.neonLime}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='starttwo'
					className={style.neonLimeTwo}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startthree'
					className={style.neonBlue}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startfour'
					className={style.neonBlueTwo}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startfive'
					className={style.neonRed}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startsix'
					className={style.neonRedTwo}
				></motion.div>
				<div className={style.books}>
					<Swiper
						slidesPerGroup={1}
						breakpoints={{
							640: {
								slidesPerView: 3,
							},
							1620: {
								slidesPerView: 4,
							},
						}}
						modules={[Autoplay]}
						speed={3000}
						autoplay={{
							delay: 0,
							disableOnInteraction: false,
						}}
						loop
						slidesPerView={2}
					>
						{booksFirst.map((book) => (
							<SwiperSlide key={book.stringOne} className={style.profile}>
								<img
									className={style.imgBook}
									src={book.img}
									alt={book.stringOne}
								/>
								<p className={style.name}>{book.stringOne}</p>
								<p className={style.role}>{book.stringTwo}</p>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
				<div className={style.books}>
					<Swiper
						slidesPerGroup={1}
						breakpoints={{
							640: {
								slidesPerView: 3,
							},
							1620: {
								slidesPerView: 4,
							},
						}}
						modules={[Autoplay]}
						speed={3000}
						autoplay={{
							delay: 0,
							disableOnInteraction: false,
							reverseDirection: true,
						}}
						loop
						slidesPerView={2}
					>
						{booksSecond.map((book) => (
							<SwiperSlide key={book.stringOne} className={style.profile}>
								<img
									className={style.imgBook}
									src={book.img}
									alt={book.stringOne}
								/>
								<p className={style.name}>{book.stringOne}</p>
								<p className={style.role}>{book.stringTwo}</p>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
				<div className={style.books}>
					<Swiper
						slidesPerGroup={1}
						breakpoints={{
							640: {
								slidesPerView: 3,
							},
							1620: {
								slidesPerView: 4,
							},
						}}
						modules={[Autoplay]}
						speed={3000}
						autoplay={{ delay: 0, disableOnInteraction: false }}
						loop
						slidesPerView={2}
					>
						{booksThird.map((book) => (
							<SwiperSlide key={book.stringOne} className={style.profile}>
								<img
									className={style.imgBook}
									src={book.img}
									alt={book.stringOne}
								/>
								<p className={style.name}>{book.stringOne}</p>
								<p className={style.role}>{book.stringTwo}</p>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
			</div>
		</div>
	);
};

export default Team;
